// Icons fork: all ad networks (Freestar / InMobi / Google) have been removed.
//
// This used to drive ZenGM's Freestar ad slots. We ship no ads, so this is a
// no-op stub that preserves the `ads` API surface the rest of the UI calls
// (setLoadingDone / init / stop / adBlock / trackPageview / refreshAll).

class Ads {
	skyscraper = {
		updateDislay(_initial: boolean) {},
	};

	setLoadingDone(_type: "accountChecked" | "uiRendered") {}

	init() {}

	stop() {}

	adBlock() {
		return false;
	}

	trackPageview(_path: string) {}

	refreshAll() {}
}

export const ads = new Ads();
